import { Button } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import React, { Component } from 'react';
import cx from 'classnames';

const styles = theme => ({
  button: {
    marginLeft: theme.spacing(1),
  },
  noMargin: {
    marginLeft: 0,
  },
});

class ArchTableToolbarActionButton extends Component {
  render() {
    const { noMargin, children, classes, ...rest } = this.props;
    return (
      <>
        <Button
          disableElevation
          variant="contained"
          color="inherit"
          {...rest}
          className={cx(classes.button, noMargin && classes.noMargin)}
        >
          {children}
        </Button>
      </>
    );
  }
}

export default withStyles(ArchTableToolbarActionButton, styles, {
  withTheme: true,
});
